/** Topic selection only: answers remain self reports and never contribute to numeric scores. */
export const PERSONALIZATION_TOPICS = [
  'relationship', 'family', 'communication', 'affection', 'conflict', 'support',
  'independence', 'values', 'wellbeing', 'activities', 'gifts', 'food', 'growth',
] as const;
export type PersonalizationTopic = typeof PERSONALIZATION_TOPICS[number];

export const QUESTIONNAIRE_TOPICS: Record<string, readonly PersonalizationTopic[]> = {
  relationshipGoals: ['relationship', 'growth'],
  relationshipKind: ['relationship'],
  livingArrangement: ['relationship', 'family'],
  coupleStrength: ['relationship', 'support'],
  parentingSituation: ['family'],
  affectionReceived: ['affection', 'gifts'],
  affectionGiven: ['affection', 'gifts'],
  enjoyableMoments: ['activities', 'affection'],
  timeTogetherFrequency: ['activities', 'relationship'],
  talkingComfort: ['communication'],
  feelingListenedTo: ['communication', 'support'],
  stressBetweenUs: ['wellbeing', 'conflict'],
  feelingValued: ['affection', 'support'],
  disagreementResponse: ['conflict', 'communication'],
  reconnectingAfterArguments: ['conflict', 'affection'],
  supportWhenStruggling: ['support', 'wellbeing'],
  personalTimeBalance: ['independence', 'relationship'],
  bigDecisionApproach: ['communication', 'values'],
  valuesAgreement: ['values'],
  personalTrust: ['relationship', 'support'],
  physicalAffectionFit: ['affection'],
  currentDifficulty: ['relationship', 'support'],
  wantedFromPartner: ['relationship', 'support'],
  wantedContribution: ['relationship', 'growth'],
  futureFeelings: ['relationship', 'values'],
};

export const CORE_QUESTIONNAIRE_FIELDS = new Set([
  'relationshipGoals', 'relationshipKind', 'livingArrangement', 'parentingSituation', 'affectionReceived',
]);

/** Constraints on how to offer any gesture, independent of the activity category. */
export const SUGGESTION_CONSTRAINT_FIELDS = new Set([
  ...CORE_QUESTIONNAIRE_FIELDS,
  'personalTimeBalance', 'timeTogetherFrequency', 'physicalAffectionFit',
  'stressBetweenUs', 'supportWhenStruggling', 'currentDifficulty',
  'wantedFromPartner', 'bigDecisionApproach',
]);
